export const Screensize = {
  XXL: 1920,
  L: 1360,
  M: 1024,
  S: 760,
  XS: 390,
  base: 320,
};
